import { usePortalAccess } from './usePortalAccess';

/**
 * Registry 3단계 (설계 §5.1). 상위가 하위를 포함하므로(`/me` 가 실효 권한을 준다) 각각 has() 하나로 판정한다.
 * 화면 힌트일 뿐 실제 차단은 서버(lh-registry 라우트 가드)다.
 * - canRead  `menu.registry`   조회
 * - canWrite `registry.writer` 테이블 추가·manifest PR·스키마 변경
 * - canAdmin `registry.admin`  promote·connection 등록·OM↔conn_id 매핑·domain 관리
 */
export function useRegistryAccess() {
  const { loading, has } = usePortalAccess();
  return { loading, canRead: has('menu.registry'), canWrite: has('registry.writer'), canAdmin: has('registry.admin') };
}
